import React, { useEffect, useState } from "react";
import GoogleMapReact from 'google-map-react';
import { useTranslation } from "react-i18next";


const GoogleMapStyle = ({
  containerClassName = "google-map",
  mapClassName = "map",
  mapSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3271.1289475543736!2d138.6214102772162!3d-34.92830287471521!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ab0ceb35eb6c4b9%3A0x4bf54554557ae46e!2zbDIvMTM1IEZ1bGxhcnRvbiBSZCwgUm9zZSBQYXJrIFNBIDUwNjfmvrPlpKfliKnkupo!5e0!3m2!1szh-CN!2shk!4v1755846053994!5m2!1szh-CN!2shk",
}) => {
  const [mapsrc, setMapSrc] = useState(mapSrc)
  const { i18n } = useTranslation();
  console.log(i18n, 'insadasdasd');

  useEffect(() => {
    const lang = {
      "en": "en",
      "zh": "zh-CN"
    }
    const mapSrc = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3271.1289475543736!2d138.6214102772162!3d-34.92830287471521!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ab0ceb35eb6c4b9%3A0x4bf54554557ae46e!2zbDIvMTM1IEZ1bGxhcnRvbiBSZCwgUm9zZSBQYXJrIFNBIDUwNjfmvrPlpKfliKnkupo!5e0!3m2!1s${lang[i18n.language]}!2shk!4v1755846053994!5m2!1s${lang[i18n.language]}!2shk`;
    setMapSrc(mapSrc)
  }, [i18n.language])
  const mapStyle = {
    position: "relative",
    display: "block",
    top: "1px",
    zoom: 3.75,
    width: '100%',
    paddingTop: 20,
    paddingRight: 3,
    paddingLeft: 3,
  };

  return (
    <div className={containerClassName}>
      <section style={mapStyle} className={mapClassName}>
        <iframe src={mapsrc} allowFullScreen style={{ width: "100%", borderRadius: 2 }}></iframe>
      </section>
    </div>
  );
};

export default GoogleMapStyle;













